import { useReadQuery } from '@apollo/client';

const useReadProductBasicDetails = queryRef => {
  const { loading, error, data, refetch } = useReadQuery(queryRef);

  return {
    loading: loading || !data,
    error,
    data: data?.basicDetails,
    rawLoading: loading,
    rawData: data,
    refetch,
  };
};

export default useReadProductBasicDetails;
